module.exports = __webpack_public_path__ + "static/media/assorty.c0252e48.png";